module.exports = "images/warning.8a82feb0.png";